import { useEffect, useState } from "react";
import Reports from "./Reports"
import { useDispatch, useSelector } from "react-redux";
import { getReportList, isLinkSaved, saveUpdateLink, deleteLink, saveUpdateCategory } from "Store/Report/ReportList/ReportListAction";
import userProfileSelectors from '../../../../redux/UserProfile/selectors'
import ConfirmationBee from "../../../assets/images/ConfirmationBee.svg";
import SuccessBee from "../../../assets/images/SuccessBee.svg";
import RejectedBee from "../../../assets/images/PenndingApproval/Rejected Bee.png";
import { popupInitialData, base64ToArrayBuffer, saveByteArray } from "utils";
import { getE1UploadTemplateExcelData, setE1UploadTemplateExcelData } from 'Store/Report/ReportList/ReportListAction';

const ReportsContainer = () => {
    const dispatch = useDispatch();
    const [showAlert, setShowAlert] = useState(false)
    const [collapse, setCollapse] = useState({ state: false, index: 0 })
    const [values, setValues] = useState<any>({})
    const [errors, setErrors] = useState<any>({})
    const [userAction, setUserAction] = useState('')
    const [showCategoryPopup, setShowCategoryPopup] = useState(false)
    const [categoryName, setCategoryName] = useState('')
    const [categoryError, setCategoryError] = useState('')
    const [editCategoryId, setEditCategoryId] = useState<number | null>(null)
    const [popupContent, setPopupContent] = useState<any>({
        ...popupInitialData,
        popupOutlinebtnOnclick: () => { },
        popupPrimarybtnOnclick: () => { },
        hideDialog: () => { }
    });

    const breadcrumlist = [
        { text: 'Reports', key: 'f1', href: '/ordermanagement', onClick: (e: any) => { e.preventDefault(); } }, {}
    ]

    const { 
        reportList,
        userData,
        isLinkSavedFlag,
        e1UploadTemplateExcelData
     }: any = useSelector((state: any) => ({
        reportList: state.ReportListReducer.reportList,
        isLinkSavedFlag: state.ReportListReducer.isLinkSavedFlag,
        userData: userProfileSelectors.getUserDetails(state),
        e1UploadTemplateExcelData: state.ReportListReducer?.E1UploadTemplateExcelData,
    }));

    useEffect(() => {
        dispatch(getReportList());
    }, [])

    useEffect(() => {
        if (typeof values?.linkType?.value === 'boolean' && values?.linkType?.value) {
            setIconList(iconListAll?.slice(-4))
        } else if (typeof values?.linkType?.value === 'boolean' && values?.linkType?.value === false) {
            setIconList(iconListAll?.slice(0, 4))
        } else {
            setIconList(iconListAll)
        }
    }, [values?.linkType?.value])

    const dismissSuccessAlert = () => {
        dispatch(isLinkSaved(undefined))
        setShowAlert(false)
    }

    useEffect(() => {
        if (typeof isLinkSavedFlag === 'boolean') {
            setShowAlert(true)
        }
        if (isLinkSavedFlag) {
            setCollapse({ ...collapse, state: false })
            hideCategoryPopup()
        }
    }, [isLinkSavedFlag])

    useEffect(() => {
        if (showAlert) {
            setTimeout(() => {
                dismissSuccessAlert()
            }, 3000)
        }
    }, [showAlert])

    const onClickAddEditCategory = (e: any, index: number, categoryId: number, linkValues?: any) => {
        setCollapse({ state: true, index: index })
        setValues((prev: any)=> ({
            ...prev, 
            categoryId: categoryId, 
            linkText: linkValues?.categoryReportName,
            reportId: linkValues?.categoryReportId,
            linkURL : linkValues?.categoryReportUrl,
            linkType: linkTypeOptions?.find((option: any) => option?.value === linkValues?.isExternalReport),
            icon : linkValues?.reportIconUrl
        }))
    }

    const hideAddEditLinkPopup = (index: number) => {
        setCollapse({ state: false, index: index })
        setValues({})
        setErrors({})
    }

    const cancelAddEditLinkPopup = (index: number) => {
        hideAddEditLinkPopup(index)
    }

    const saveLink = () => {
        const isValid = validateLinkValues()
        if (isValid) {
            let payload = {
                categoryReportId: values?.reportId ?? 0,
                categoryReportName: values?.linkText?.trim(),
                categoryReportUrl: values?.linkURL?.trim(),
                isExternalReport: values?.linkType?.value,
                categoryId: values?.categoryId,
                reportIconFileName: values?.icon,
                savedBy: userData?.emailId
            }
            dispatch(saveUpdateLink(payload))
        }
    }

    const hideDialog = () => setPopupContent({ ...popupContent, isDialogVisible: false })

    const deleteReportLink = (reportId: number, reportName: string) => {
        setPopupContent({
            ...popupContent,
            titleImg: ConfirmationBee,
            title: "CONFIRMATION",
            isDialogVisible: true,
            isTitleWarning: false,
            subtextcontent: <><p>Are you sure you want to delete <strong>{reportName}</strong>?</p></>,
            primaryBtnText: "Yes",
            outlineBtnText: "No",
            isSingleConfirmationBtn: false,
            hideDialog: hideDialog,
            popupPrimarybtnOnclick: () => {
              hideDialog();
              dispatch(deleteLink(reportId, userData?.emailId))
            },
            popupOutlinebtnOnclick: () => {
              hideDialog();
            }
          });
    }


    const iconListAll = [
        {
            id: 1
        },
        {
            id: 2
        },
        {
            id: 3
        },
        {
            id: 4
        },
        {
            id: 5
        },
        {
            id: 6
        },
        {
            id: 7
        },
        {
            id: 8
        }
    ]

    const [iconList, setIconList] = useState<any>(iconListAll)

    const linkTypeOptions = [
        { label: 'Internal', value: false },
        { label: 'External', value: true }
    ]


    const validateLinkText = (value: any) => {
        let isValid = true;
        let error = ""
        if (!value) {
            isValid = false
            error = "Please provide link text"
        } else if (value?.length > 100) {
            isValid = false;
            error = "Please provide link text less than 100 characters"
        } else {
            if(userAction !== 'update'){
                let reportsTexts = reportList?.reduce((acc: any, category: any) => {
                    if (category?.categoryId === values?.categoryId) {
                        acc = category?.reports?.map((report: any) => report?.categoryReportName?.toLowerCase()?.trim())?.includes(value?.toLowerCase()?.trim())
                    }
                    return acc
                }, false)
                if (reportsTexts) {
                    isValid = false;
                    error = "Report link already exists"
                } else {
                    error = ""
                }

            } else {
                error = ""
            }
        }
        setErrors((prev: any) => ({ ...prev, linkText: error }))
        return isValid
    }

    const validateLinkType = (value: any) => {
        let isValid = true;
        let error = ""
        if (!value) {
            isValid = false
            error = "Please select link type"
        } else {
            error = ""
        }
        setErrors((prev: any) => ({ ...prev, linkType: error }))
        return isValid
    }

    const validateLinkURL = (value: any) => {
        let isValid = true;
        let error = ""
        if (!value) {
            isValid = false
            error = "Please provide link URL"
        } else if (values?.linkType?.value) {
            try {
                const newUrl = new URL(value);
                if (newUrl.protocol === 'http:' || newUrl.protocol === 'https:') {
                    error = ""
                } else {
                    isValid = false
                    error = "Please provide valid link URL with http or https"
                }
            } catch (err) {
                isValid = false
                error = "Please provide valid link URL with http or https"
            }
        } else {
            error = ""
        }
        setErrors((prev: any) => ({ ...prev, linkURL: error }))
        return isValid
    }

    const validateLinkIcon = (value: any) => {
        let isValid = true;
        let error = ""
        if (!value) {
            isValid = false
            error = "Please select icon"
        } else {
            error = ""
        }
        setErrors((prev: any) => ({ ...prev, icon: error }))
        return isValid
    }



    const validateLinkValues = () => {
        const isTextValid = validateLinkText(values?.linkText)
        const isTypeValid = validateLinkType(values?.linkType)
        const isURLValid = validateLinkURL(values?.linkURL)
        const isValidIcon = validateLinkIcon(values?.icon);
        return (isTextValid && isTypeValid && isURLValid && isValidIcon);
    }

    const handleChange = (e: any) => {
        if (e?.target?.name === "linkText") {
            validateLinkText(e?.target?.value)
        } else {
            validateLinkURL(e?.target?.value)
        }
        setValues((prev: any) => ({ ...prev, [e?.target?.name]: e?.target?.value }))
    }

    const onChangeLinkType = (value: any) => {
        validateLinkType(value)
        setValues((prev: any) => ({ ...prev, linkType: value, icon: '' }))
        if(value?.value){
            setIconList(iconListAll?.slice(-4))
        } else {
            setIconList(iconListAll?.slice(0,4))
        }
    }

    const onSelectIcon = (value: string) => {
        validateLinkIcon(value)
        setValues((prev: any) => ({ ...prev, icon: value }))
    }

    const validateCategoryName = (value: string) => {
        let isValid = true
        if(!value){
            setCategoryError("Category Name is a Required Field")
            isValid = false
        } else if(value?.length > 50){
            setCategoryError("Please provide Category Name in less than 50 characters")
            isValid = false
        } else if(reportList?.map((category:any) => category?.categoryName)?.includes(value?.trim()) && !editCategoryId){
            setCategoryError("Category already exists")
            isValid = false
        } else{
            setCategoryError("")
        }
        return isValid
    }

    const handleCategoryNameChange = (e: any) => {
        setCategoryName(e?.target?.value)
        validateCategoryName(e?.target?.value)
    }

    const saveCategory = () => {
        let isValid = validateCategoryName(categoryName)
        if(isValid){
            let payload = {
                categoryId: editCategoryId ?? 0,
                categoryName: categoryName?.trim(),
                savedBy: userData?.emailId
            }
            dispatch(saveUpdateCategory(payload))
        }
    }

    const hideCategoryPopup = () => {
        setCategoryError('')
        setShowCategoryPopup(false)
        setCategoryName('')
        setEditCategoryId(null)
    }

    const editCategory = (categoryName: string, categoryId: number) => {
        setShowCategoryPopup(true)
        setUserAction('updateCategory')
        setCategoryName(categoryName)
        setEditCategoryId(categoryId)
    }

    const handleDownloadReport = async (e: any) => {
        e.preventDefault();
        dispatch(getE1UploadTemplateExcelData({ savedBy: userData?.emailId }));
    };

    // Handle E1 Upload Template Excel download
    useEffect(() => {
        if (
         e1UploadTemplateExcelData?.status === "success" &&
         e1UploadTemplateExcelData?.response
     ) {
         const bytes = base64ToArrayBuffer(e1UploadTemplateExcelData.response);
         const fileName = "E1_Upload_Template";
     saveByteArray(
       fileName,
       bytes,
       "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
     );

     let decriptionTxt = <p>E1 Upload Template exported successfully</p>;
     setPopupContent({
       ...popupContent,
       titleImg: SuccessBee,
       title: "SUCCESS",
       isDialogVisible: true,
       isTitleWarning: false,
       isCommentboxVisible: false,
       isCommentBoxRequire: false,
       subtextcontent: decriptionTxt,
       primaryBtnText: "",
       outlineBtnText: "Close",
       isSingleConfirmationBtn: true,
       hideDialog: hideDialog,
       popupOutlinebtnOnclick: () => {
         dispatch(
           setE1UploadTemplateExcelData({ response: {}, status: "idle" })
         );
         hideDialog();
       },
     });
   } else if (e1UploadTemplateExcelData?.status === "failed") {
     let decriptionTxt = (
       <div>
         <p>E1 Upload Template export failed</p>
       </div>
     );
     setPopupContent({
       ...popupContent,
       titleImg: RejectedBee,
       title: "ERROR",
       isDialogVisible: true,
       isTitleWarning: false,
       subtextcontent: decriptionTxt,
       primaryBtnText: "",
       outlineBtnText: "Close",
       isSingleConfirmationBtn: true,
       isCommentboxVisible: false,
       isCommentBoxRequire: false,
       hideDialog: hideDialog,
       popupOutlinebtnOnclick: () => {
         hideDialog();
       },
     });

     console.error("[Reports-container] E1 Export: Export failed");
   }
 }, [e1UploadTemplateExcelData]);

    return (
        <Reports
            breadcrumlist={breadcrumlist}
            showAlert={showAlert}
            onClickAddEditCategory={onClickAddEditCategory}
            collapse={collapse}
            reportList={reportList}
            iconList={iconList}
            cancelAddEditLinkPopup={cancelAddEditLinkPopup}
            linkTypeOptions={linkTypeOptions}
            handleChange={handleChange}
            onChangeLinkType={onChangeLinkType}
            values={values}
            errors={errors}
            onSelectIcon={onSelectIcon}
            saveLink={saveLink}
            isLinkSavedFlag={isLinkSavedFlag}
            dismissSuccessAlert={dismissSuccessAlert}
            deleteReportLink={deleteReportLink}
            setUserAction={setUserAction}
            userAction={userAction}
            showCategoryPopup={showCategoryPopup} 
            setShowCategoryPopup={setShowCategoryPopup}
            handleCategoryNameChange={handleCategoryNameChange}
            categoryName={categoryName}
            categoryError={categoryError}
            saveCategory={saveCategory}
            hideCategoryPopup={hideCategoryPopup}
            editCategory={editCategory}
            editCategoryId={editCategoryId}
            popupContent={popupContent}
            handleDownloadReport = {handleDownloadReport}
        />
    )
}

export default ReportsContainer